import { render, staticRenderFns } from "./modalFiltroGeneral.vue?vue&type=template&id=0280b18f&"
import script from "./modalFiltroGeneral.vue?vue&type=script&lang=js&"
export * from "./modalFiltroGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports